module.exports = __webpack_public_path__ + "static/media/SalesOperation.cced33a3.svg";